// Import mutations
import {
    DESTROY_SESSION,
    SET_SESSION_CONTACT_ID,
    SET_SESSION_EXIST,
    SET_SESSION_SELECTED_TENANT,
    SET_SESSION_TENANTS,
    SET_SESSION_USER,
    RESET_PENDING_REQUESTS,
    INCREMENT_PENDING_REQUESTS,
    DECREMENT_PENDING_REQUESTS
} from './mutation-types.js';

// Initial state
const state = () => ({
    sessionContactId:      null,
    sessionExists:         false,
    sessionSelectedTenant: null,
    sessionTenants:        null,
    sessionUser:           null,
    pendingRequests:       0
});

// Getters
const getters = {};

// Actions
const actions = {
    /**
     * Set session contact id
     */
    setContactId (context, { contactId }) {
        context.commit(SET_SESSION_CONTACT_ID, contactId);
    },

    /**
     * Set session exist
     */
    setSessionExists (context,  { sessionExists }) {
        context.commit(SET_SESSION_EXIST, sessionExists);
    },

    /**
     * Set session selected tenant
     */
    setSessionSelectedTenant (context, { selectedTenant }) {
        context.commit(SET_SESSION_SELECTED_TENANT, selectedTenant);
    },

    /**
     * Set session tenants
     */
    setSessionTenants (context, { tenants }) {
        context.commit(SET_SESSION_TENANTS, tenants);
    },

    /**
     * Set session user
     */
    setSessionUser (context, { user }) {
        context.commit(SET_SESSION_USER, user);
    },

    destroySession (context) {
        context.commit(DESTROY_SESSION);
    },

    resetPendingRequests (context) {
        context.commit(RESET_PENDING_REQUESTS);
    },

    incrementPendingRequests (context) {
        context.commit(INCREMENT_PENDING_REQUESTS);
    },

    decrementPendingRequests (context) {
        context.commit(DECREMENT_PENDING_REQUESTS);
    }
};

// Mutations
const mutations = {
    [DESTROY_SESSION]: (state) => {
        state.sessionExists = false;
    },
    [SET_SESSION_CONTACT_ID]: (state, contactId) => {
        state.sessionContactId = contactId;
    },
    [SET_SESSION_EXIST]: (state, sessionExists) => {
        state.sessionExists = sessionExists;
    },
    [SET_SESSION_SELECTED_TENANT]: (state, selectedTenant) => {
        state.sessionSelectedTenant = selectedTenant;
    },
    [SET_SESSION_TENANTS]: (state, tenants) => {
        state.sessionTenants = tenants;
    },
    [SET_SESSION_USER]: (state, user) => {
        state.sessionUser = user;
    },
    [RESET_PENDING_REQUESTS]: (state) => {
        state.pendingRequests = 0;
    },
    [INCREMENT_PENDING_REQUESTS]: (state) => {
        state.pendingRequests = state.pendingRequests + 1;
    },
    [DECREMENT_PENDING_REQUESTS]: (state) => {
        state.pendingRequests = Math.max(0, state.pendingRequests - 1);
    }
};

// Export module
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
